const customJsonstringify = str => JSON.stringify(str).replace(/([&"'<>])/g, ( char) => {
  switch (char) {
  case '&':
      return '\u0026'
  case '<':
      return '\u003c'
  case '>': 
      return '\u003e'
  case '"':
      return '\u0022'
  case "'":
      return "\u0027"
  default:
      return char
  }
})

module.exports = function(locale, preview, idsList = []) {
  return `
  fragment SitemapSectionFragment on SitemapSection {
  __typename
  sys {
    id
  }
  title
  parentPageCollection(limit: 1) {
    items {
      __typename
      ... on HomePage {
        sys {
          id
        }
        slug
        breadcrumbTitle
        sitemapTitle
      }
      ... on ContentPage {
        sys {
          id
        }
        slug
        breadcrumbTitle
        sitemapTitle
      }
      ... on ArticleList {
        sys {
          id
        }
        slug
        breadcrumbTitle
        sitemapTitle
      }
      ... on LinkButton {
        sys {
          id
        }
        link
        linkText
      }
      ... on CompareProducts {
        sys {
          id
        }
        refParentPage: parentPage {
          sys {
            id
          }
          slug
        }
      }
    }
  }
}

{
  sitemapSectionCollection(locale: "${locale}", preview: ${preview}, limit: ${
    idsList.length
  }, where: {sys: {id_in: ${customJsonstringify(idsList)}}}) {
    items {
      ...on SitemapSection{
        ...SitemapSectionFragment
      }
      childPageCollection {
        items {
          __typename
          ... on Product {
            sys {
              id
            }
            slug
            breadcrumbTitle	
            sitemapTitle
          }
          ... on CompareProducts {
            sys {
              id
            }
            refParentPage: parentPage {
              sys {
                id
              }
              slug
            }
          }
          ... on SitemapSection {
            ...SitemapSectionFragment
          }
        }
      }
    }
  }
}`;
};
